import styled, { css } from 'styled-components';
import { Box, MenuItem } from '@bechtel/gds';

interface MenuItemStyledProps {
  isActive: boolean;
  isDisabled: boolean;
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    display: flex;
    font-size: ${theme.fontSizes[400]};
    color: ${theme.colors.red[500]};
    padding-left: ${theme.spacings[500]};
    white-space: nowrap;
    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.bechtel.blue[100]};
    }
    ${(props: MenuItemStyledProps) =>
      props.isActive &&
      css`
        background-color: ${theme.colors.bechtel.blue[100]};
        &:hover {
          background-color: ${theme.colors.bechtel.blue[100]};
        }
      `}
    ${(props: MenuItemStyledProps) =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.6;
      `}
  `}
`;

export const PopperContainerStyled = styled(Box)`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]};
    display: flex;
    align-items: baseline;
    position: absolute;
    z-index: 1;
    top: ${theme.spacings[700]};
    right: 0;
  `}
`;
